import React, { useEffect, useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

function AdPopup() {
  const [ad, setAd] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchActiveAd = async () => {
      try {
        const response = await axios.get(`${API_URL}/ads/active`);
        const activeAd = response.data;

        if (!mounted || !activeAd?.image_url) return;

        const dismissedId = sessionStorage.getItem("dismissedAdPopupId");
        if (dismissedId === String(activeAd.id)) return;

        setAd(activeAd);
        setVisible(true);
      } catch (err) {
        console.error("Error loading advertisement popup:", err);
      }
    };

    fetchActiveAd();

    return () => {
      mounted = false;
    };
  }, []);

  const closePopup = () => {
    if (ad?.id) {
      sessionStorage.setItem("dismissedAdPopupId", String(ad.id));
    }
    setVisible(false);
  };

  if (!visible || !ad) return null;

  const image = (
    <img
      src={ad.image_url}
      alt={ad.title || "Quảng cáo"}
      className="ad-popup-image"
    />
  );

  return (
    <div className="ad-popup-backdrop" role="dialog" aria-modal="true">
      <div className="ad-popup-card">
        <button
          type="button"
          className="ad-popup-close"
          onClick={closePopup}
          aria-label="Đóng quảng cáo"
        >
          ×
        </button>
        {ad.link_url ? (
          <a
            href={ad.link_url}
            target="_blank"
            rel="noreferrer"
            onClick={closePopup}
            className="ad-popup-link"
          >
            {image}
          </a>
        ) : (
          image
        )}
      </div>
    </div>
  );
}

export default AdPopup;
